<div id="houseType" data-cy="house-type">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.houseDetails.steps.houseType.title' | translate"
      data-cy="house-type-title"
    ></ife-title>

    <div class="flex flex-wrap checkboxPadding justify-center">
      <div class="justify-center w-full sm:w-auto">
        <ife-checkbox
          id="house"
          [attr.data-cy]="houseType.house"
          [value]="houseType.house"
          formControlName="houseType"
          [image]="'./assets/evc/img/house.svg'"
          [caption]="'modules.evcQuote.steps.houseDetails.steps.houseType.options.house' | translate"
        >
        </ife-checkbox>
        <div
          *ngIf="init && control.get('houseType').value === houseType.house"
          class="mt-4 sm:mt-8 text-xs text-gray-400 text-center full-width sm:max-w-md"
          data-cy="preselected-disclaimer"
        >
          {{ "modules.evcQuote.general.preSelected" | translate }}
        </div>
      </div>

      <div class="justify-center w-full sm:w-auto">
        <ife-checkbox
          id="sharedResidence"
          [attr.data-cy]="houseType.sharedResidence"
          [value]="houseType.sharedResidence"
          formControlName="houseType"
          [image]="'./assets/evc/img/apartment.svg'"
          [caption]="'modules.evcQuote.steps.houseDetails.steps.houseType.options.sharedResidence' | translate"
        >
        </ife-checkbox>
        <div
          *ngIf="init && control.get('houseType').value === houseType.sharedResidence"
          class="mt-4 sm:mt-8 text-xs text-gray-400 text-center full-width sm:max-w-md"
          data-cy="preselected-disclaimer"
        >
          {{ "modules.evcQuote.general.preSelected" | translate }}
        </div>
      </div>
    </div>

    <div
      [@inOutAnimation]
      id="parkingSpot"
      data-cy="parking-spot"
      *ngIf="control.get('houseType').value === houseType.sharedResidence"
    >
      <div class="mt-16">
        <ife-title
          [title]="'modules.evcQuote.steps.houseDetails.steps.houseType.parkingSpot.title' | translate"
          data-cy="parking-spot-title"
        ></ife-title>
      </div>

      <div
        class="mx-auto max-w-screen-sm my-20"
        *ngIf="control.get('parkingSpot').dirty && control.get('parkingSpot').invalid"
        data-cy="house-type-notification"
      >
        <ife-notification
          [notificationType]="notificationType.warning"
          [notificationString]="'modules.evcQuote.steps.houseDetails.steps.houseType.error' | translate"
        >
        </ife-notification>
      </div>

      <div class="flex flex-wrap checkboxPadding justify-center">
        <ife-checkbox
          id="parkingSpotYes"
          data-cy="parking-spot-yes"
          class="w-full sm:w-auto"
          [value]="true"
          formControlName="parkingSpot"
          [image]="'./assets/general/img/yes.svg'"
          [caption]="'general.yes' | translate"
        >
        </ife-checkbox>
        <ife-checkbox
          id="parkingSpotNo"
          data-cy="parking-spot-no"
          class="w-full sm:w-auto"
          [value]="false"
          formControlName="parkingSpot"
          [image]="'./assets/general/img/no.svg'"
          [caption]="'general.no' | translate"
        >
        </ife-checkbox>
      </div>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
